
/**
 * 주문 유형
 */
export type GetOrderInfo200OrderType = typeof GetOrderInfo200OrderType[keyof typeof GetOrderInfo200OrderType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetOrderInfo200OrderType = {
  ONE_TIME: 'ONE_TIME',
  SUBSCRIPTION: 'SUBSCRIPTION',
} as const;
